import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ToolActivationModal } from './ToolActivationModal';
import { Layout, Copy, Rocket } from 'lucide-react';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ReplicModal: React.FC<Props> = ({ open, onOpenChange }) => {
  useLanguage();
  return (
    <ToolActivationModal
      open={open}
      onOpenChange={onOpenChange}
      toolName="Replic"
      toolColor="#2563EB"
      headline={translateInterfaceText("Crie, Replique e Publique Sites em Minutos")}
      subheadline={translateInterfaceText("Ative seu acesso gratuito à Replic e comece com seus dados já integrados à Host VSL.")}
      benefitsTitle={translateInterfaceText("O que você ganha com a Replic")}
      benefits={[
        {
          icon: Layout,
          text: translateInterfaceText("Páginas ultra rápidas em HTML"),
          description: translateInterfaceText("Crie páginas de alta conversão em poucos cliques."),
        },
        {
          icon: Copy,
          text: translateInterfaceText("Clone páginas validadas"),
          description: translateInterfaceText("Modele páginas com um clique e personalize do seu jeito."),
        },
        {
          icon: Rocket,
          text: translateInterfaceText("Delay sincronizado com vídeo"),
          description: translateInterfaceText("Faça sessões e botões surgirem no momento exato do vídeo."),
        },
      ]}
      formTitle={translateInterfaceText("Seu acesso está quase pronto")}
      formDescription={translateInterfaceText("Confira seus dados e crie sua senha para liberar sua conta.")}
      planBadge={translateInterfaceText("Plano gratuito")}
      planText={translateInterfaceText("Você poderá explorar a ferramenta, conhecer a experiência e testar antes de decidir avançar para um plano pago.")}
      successTitle={translateInterfaceText("Sua conta na Replic foi criada com sucesso")}
      successText={translateInterfaceText("Seu acesso inicial já está pronto. Agora você já pode entrar e começar a criar suas páginas.")}
      successCta={translateInterfaceText("Acessar Replic")}
      onAccessTool={() => window.open('https://replic.com.br', '_blank')}
      loginUrl="https://app.replic.com.br/login"
    />
  );
};
